import { createContext } from "react";

const appContext = createContext();

export { appContext };
